// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDRLQm0vhJMhHuXSwbMYOBvtbgMtj4Kjh0",
  authDomain: "rozgaar-5dfc5.firebaseapp.com",
  projectId: "rozgaar-5dfc5",
  storageBucket: "rozgaar-5dfc5.appspot.com",
  messagingSenderId: "778431744945",
  appId: "1:778431744945:web:90675c917ed8929c1c4b90"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);
